export const ZOHO_CONFIG = {
  apiKey: import.meta.env.VITE_ZOHO_API_KEY || '',
  baseUrl: 'https://campaigns.zoho.com/api/v1.1',
  syncInterval: 5 * 60 * 1000, // 5 minutes
  defaultHeaders: {
    'Content-Type': 'application/json'
  },
  endpoints: {
    campaigns: '/campaigns',
    targets: '/targets',
    analytics: '/analytics'
  }
};